import "@rothoblaas/design-system/styles.css";
import { FC } from "react";
import { createRoot } from "react-dom/client";
import "../../colors.css";
import App from "../../components/App";
import SingleModuleAppLogo from "../../components/SingleModuleAppLogo";
import "../../global.css";
import { ACCESS_SCOPE_DECK_DESIGNER } from "../../http/types/accessControl";
import { installDiagnosticsCapture } from "../../utils/diagnostics";
import AuthenticatedApp from "./AuthenticatedApp";

const Logo: FC = () => <SingleModuleAppLogo title="Deck Designer" />;

// before rendering, so the errors of the first render are kept for the help requests
installDiagnosticsCapture();

const container = document.getElementById("root");
const root = createRoot(container!);
// Vite's dev server serves this entry at its file path (/apps/deck-designer/),
// but production nginx rewrites it to the subdomain root — no prefix there.
root.render(
  <App
    AuthenticatedApp={AuthenticatedApp}
    Logo={Logo}
    basename={import.meta.env.DEV ? "/apps/deck-designer" : undefined}
    isSingleModuleApp
    scope={ACCESS_SCOPE_DECK_DESIGNER}
  />,
);
